module.exports = __webpack_public_path__ + "static/media/AnjaBärike.21d7fd87.jpg";